import { render, staticRenderFns } from "./SalesScope.vue?vue&type=template&id=40229f18&scoped=true&"
import script from "./SalesScope.vue?vue&type=script&lang=js&"
export * from "./SalesScope.vue?vue&type=script&lang=js&"
import style0 from "./SalesScope.vue?vue&type=style&index=0&id=40229f18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40229f18",
  null
  
)

export default component.exports